<template>
  <div class="clearfix">
    <Board style="banner" />
    <Login style="float:right" />
  </div>
</template>

<script>
import Board from '@/components/information/Board.vue';
import Login from '@/components/Login.vue';

export default {
  components: { Board, Login },
};
</script>

<style lang="scss" scoped>
.banner{
  width: 520px;
}
</style>
